import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BoxImg, TruckImg, NailingZoneImg } from '../../../../../../assets/images/warranty-claim';
import CTAButton from '../../../../CTAButton';
import Accordion from '../../../../ComponentLibrary/oc-accordion';
import BackButton from '../../../shared/BackButton';
import ClaimArea from '../../helpers/claim-area';
import { Hrule, HeaderWrap } from '../../helpers/styles';
import { setFormData, setStep, incrementStep, decrementStep } from '../../redux/action';
import styles from '../07-documents/index.module.scss';

const WarrantyShingles = () => {
  const dispatch = useDispatch();
  const {
    formData,
    metadata: { pqsResponse },
    isFetching,
    disableSubmitBtn,
  } = useSelector(state => state);

  return (
    <>
      <HeaderWrap>
        <BackButton
          analytics={{
            'data-track': 'form-back',
            'data-track-form-name': 'Submit Claim Shingles Sample',
            'data-track-form-step': 'step 9 - shingles sample',
          }}
          onClick={() => dispatch(decrementStep())}
          backText="Photos"
        />

        <h2>Shingles Sample</h2>
        <ClaimArea pqsResponse={pqsResponse} />

        <h4>Shingle sample instructions</h4>
        <p>
          Two full-size shingle samples from the affected area of the roof which demonstrate the quality concern are
          required. If the cause of the complaint is color variation you must submit both a light and dark shingle
          sample.
        </p>
        <p>
          <strong>
            IMPORTANT: Please remember to replace the shingles you remove as failure to do so could result in damage to
            the roof or the interior.
          </strong>
        </p>
      </HeaderWrap>

      <Accordion label="Box Assembly Instructions" labelClassName={styles.labelHeader} imageSrc={BoxImg}>
        <p>
          Proper evaluation requires we review two full-size applied samples from your structure. It is critical the
          material is not to be folded, cut or rolled in any manner. The following steps will assist you in creating a
          sleeve for your sample. You will need one to two cardboard boxes depending on the size you obtain, a box
          cutter, and tape. For safety reasons please do not package the product the sheets of wood. Cardboard packaging
          is preferred and you do not need to add extra packing materials. Please do not use packing peanuts.
        </p>

        <Hrule />

        <p>
          {' '}
          1. The sleeve must be large enough to protect all edges of material. We suggest opening the top and bottom of
          the box and cutting in a downward motion.
        </p>

        <p>
          <img src={NailingZoneImg} alt="nailing zone" width="100%" />
        </p>

        <p>
          {' '}
          2. Place your sample in the center of the cardboard. Using your box cutter, cut around the perimeter of the
          sample, allow about 1 inch of extra cardboard on each side.
        </p>
        <ul>
          <li>
            Use the newly cut cardboard as the template to cut a second layer of cardboard from the remaining material
            or second box.
          </li>
          <li>
            The finished cardboard pieces should measure somewhere between 13x19 and 19x142 inches (variations by
            product).
          </li>
        </ul>

        <Hrule />

        <p>
          3. Place your shingle samples between the pieces of the cardboard. Be sure to include your claim number in the
          box.
        </p>

        <Hrule />

        <p>
          {' '}
          4. Tape the outside edges closed using a sturdy packaging tape. Please do not use staples to package the
          samples; they are not safe.
        </p>
      </Accordion>

      <Accordion label="Shipping Instructions" labelClassName={styles.labelHeader} imageSrc={TruckImg}>
        <p>Please use this provided document document below for shipping instructions:</p>
        <p>
          <a
            href="/en-us/warranty/Packaging_Information_for_Samples_Required_Claim_Packet.pdf"
            className="document-download"
            data-track="file-download"
            data-track-file-type=".pdf"
            data-track-file-name="Packaging Information for Samples Required Claim Packet"
            data-track-doc-type="Report"
            target="_blank"
          >
            <i className="icon icon-file-pdf" />
            <span className="title"> Packaging Information for Samples Required Claim Packet</span>
            <span className="doc-size"> PDF | 195 KB</span>
          </a>
        </p>
      </Accordion>

      <CTAButton
        onClick={() => dispatch(incrementStep())}
        data-track="form-advance"
        data-track-form-name="Submit Claim Shingles Sample"
        data-track-form-step="step 9 - shingles sample"
        element="button"
        text={isFetching ? 'Loading...' : 'Next'}
        type="submit"
        disabled={disableSubmitBtn}
      />
    </>
  );
};

export default WarrantyShingles;
